import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Learning from "@/pages/Learning";
import Recruitment from "@/pages/Recruitment";
import ForEmployers from "@/pages/ForEmployers";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ScrollToTop from "@/components/ScrollToTop";

import ProtectedRoute from "@/components/dashboard/ProtectedRoute";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Jobs from "@/pages/dashboard/Jobs";
import Applications from "@/pages/dashboard/Applications";
import Clients from "@/pages/dashboard/Clients";
import Payroll from "@/pages/dashboard/Payroll";
import PayrollHub from "@/pages/dashboard/PayrollHub";
import ResumeScreen from "@/pages/dashboard/ResumeScreen";
import RCPProgram from "@/pages/dashboard/RCPProgram";
import Users from "@/pages/dashboard/Users";
import Messages from "@/pages/dashboard/Messages";
import Invite from "@/pages/dashboard/Invite";
import IndustriesAdmin from "@/pages/dashboard/Industries";

function AppRoutes() {
  const location = useLocation();
  // Handle session_id fragment BEFORE regular routes so ProtectedRoute doesn't run first
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Navigate to="/" replace />} />
        <Route path="/learning" element={<Learning />} />
        <Route path="/recruitment" element={<Recruitment />} />
        <Route path="/payroll" element={<ForEmployers />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="applications" element={<Applications />} />
        <Route path="clients" element={<Clients />} />
        <Route path="payroll" element={<PayrollHub />} />
        <Route path="payroll-hub" element={<PayrollHub />} />
        <Route path="payroll-legacy" element={<Payroll />} />
        <Route path="screen" element={<ResumeScreen />} />
        <Route path="rcp" element={<RCPProgram />} />
        <Route path="users" element={<Users />} />
        <Route path="messages" element={<Messages />} />
        <Route path="invite" element={<Invite />} />
        <Route path="industries" element={<IndustriesAdmin />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AuthProvider>
            <AppRoutes />
            <Toaster richColors position="top-right" />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}
